import React from 'react';
import { PropTypes } from 'prop-types';
import { Radios, Button, Textarea } from '@ontruck/orc';

const RO_SUGGESTION_DISCARD_REASON_NO_PLANNING =
  'RO_SUGGESTION_DISCARD_REASON_NO_PLANNING';
const RO_SUGGESTION_DISCARD_REASON_NO_SAME_DAYS =
  'RO_SUGGESTION_DISCARD_REASON_NO_SAME_DAYS';
const RO_SUGGESTION_DISCARD_REASON_OTHER = 'RO_SUGGESTION_DISCARD_REASON_OTHER';

class DiscardForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reason: null,
      comment: '',
    };

    this.handleChangeReason = this.handleChangeReason.bind(this);
    this.handleChangeComment = this.handleChangeComment.bind(this);
  }

  handleChangeReason = (_, { value }) => {
    this.setState({ reason: value, comment: '' });
  };

  handleChangeComment = (_, { value }) => {
    this.setState({ comment: value });
  };

  handleSendRecurringOrderSuggestionDiscardReason =
    ({ reason, comment }) =>
    () => {
      const { sendRecurringOrderSuggestionDiscardReason } = this.props;
      sendRecurringOrderSuggestionDiscardReason({ reason, comment });
    };

  render() {
    const { className, t } = this.props;
    const { reason, comment } = this.state;

    const reasonItems = [
      {
        label: t(
          'discardReasons.form.reasons.RO_SUGGESTION_DISCARD_REASON_NO_PLANNING'
        ),
        value: RO_SUGGESTION_DISCARD_REASON_NO_PLANNING,
      },
      {
        label: t(
          'discardReasons.form.reasons.RO_SUGGESTION_DISCARD_REASON_NO_SAME_DAYS'
        ),
        value: RO_SUGGESTION_DISCARD_REASON_NO_SAME_DAYS,
      },
      {
        label: t(
          'discardReasons.form.reasons.RO_SUGGESTION_DISCARD_REASON_OTHER'
        ),
        value: RO_SUGGESTION_DISCARD_REASON_OTHER,
      },
    ];

    return (
      <div className={className}>
        <Radios
          girded
          size="M"
          name="recurring-suggestions-discard-reasons"
          items={reasonItems}
          onChange={this.handleChangeReason}
          fullWidth
        />

        {reason && reason === RO_SUGGESTION_DISCARD_REASON_OTHER && (
          <Textarea
            onChange={this.handleChangeComment}
            labelType="hidden"
            placeholder={t('discardReasons.form.commentsPlaceholder')}
            fullWidth
          />
        )}

        <Button
          disabled={
            !reason ||
            (reason === RO_SUGGESTION_DISCARD_REASON_OTHER && comment === '')
          }
          skin="primary"
          text={t('discardReasons.form.discardButton')}
          onClick={this.handleSendRecurringOrderSuggestionDiscardReason({
            reason,
            comment,
          })}
          fullWidth
        />
      </div>
    );
  }
}

DiscardForm.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  sendRecurringOrderSuggestionDiscardReason: PropTypes.func,
};

DiscardForm.defaultProps = {
  className: '',
  t: (t) => t,
  sendRecurringOrderSuggestionDiscardReason: () => ({}),
};

export default DiscardForm;
